
import React, { useEffect, useState } from 'react'
import { FromHead, Headline4 } from "ellow-web-ui-components-library";
import Freefield from '../../components/field/freeField'
import Button from '../../components/button'
import RadioGroup from '../../components/radioGroup';
import TagLabel from '../../components/TagLabel'
import Combodropdown from "../../components/autocomplete";
import Styles from "./styles.module.scss";
import * as CONSTANTS from '../../utils/CONSTANTS'
import * as Utils from '../../utils/EllowUtils'
import { useForm } from 'react-hook-form';
import { Error } from "@progress/kendo-react-labels";
import { skills } from '../../utils/Skill';
import { viewedpageMixpanel } from '../../utils/mixpanel';



interface Props {

  OnSubmit: any
  defaultValues: {
    workExperience: number;
    jobRoles: { name: string; id: number; }[];
    techStack: { experience: string; expertise: number; skill: { skillId: number ; skillName: string; }; stackId: number; }[];
  }
  Back: any
  loginId: string;
}



const SkillDetails: React.FC<Props> = ({
  OnSubmit,
  defaultValues,
  Back,
  loginId
}) => {
  const { v4: uuidv4 } = require('uuid');
  const [addedSkills, setAddedSkills] = useState<{ name: string, id: number, expertise: number, experience: string, other: boolean }[]>([])
  // const [addedEngineering, setAddedEngineering] = useState<{ name: string, id: number, other: boolean }[]>([])
  const [workExp, setWorkExp] = useState<any>({ years: "", months: "" })
  const [errors, setErros] = useState<{ workExp?: string, expertise?: string, experience?: string, engieering?: string, skills?: string, englishProficiency?: string}>({ workExp: "", expertise: "", experience: "", engieering: "", skills: "", englishProficiency:"" })
  // const [dropdownaddedSkills, setDropdownAddedSkills] = useState<{ name: string, id: number, expertise: number, experience: string }[]>([])
  // const [dropdownEngineering, setDropdownEngineering] = useState<{ name: string, id: number }[]>([])
  const [skillOthers, setSkillOthers] = useState<boolean>(false)
  // const [engineeringOthers, setEngineeringOthers] = useState<boolean>(false)
  const [englishProficiency , setEnglishProficiency] = useState<any>()
  const [englishProficiencyValue , setEnglishProficiencyValue] = useState<any>()
  
  useEffect(() => {
    window.scrollTo(0, 0);
    viewedpageMixpanel();
  }, []);


  useEffect(() => {
    // const jobRoles = defaultValues.jobRoles ? defaultValues.jobRoles.map(item => {
    //   return ({
    //     name: item.name, id: item.id,
    //     other: CONSTANTS.Engineering.filter(engineering => engineering.id === item.id).length === 0
    //   })
    // }) : []
    // setAddedEngineering(jobRoles) 
    const techStack = defaultValues.techStack ? defaultValues.techStack.map(item => {
      return ({
        name: item.skill.skillName, id: item.skill.skillId, expertise: item.expertise, experience: item.experience,
        other: CONSTANTS.Skills.filter(skill => skill.id === item.skill.skillId).length === 0
      })
    }) : []
    setAddedSkills(techStack)
    setWorkExp(defaultValues.workExperience ? {
      years: Utils.workexperience(defaultValues.workExperience, 0), months: Utils.workexperience(defaultValues.workExperience, 1)
    } : { years: "", months: "" })

  }, [defaultValues])


  const skillChange = (e: any, skill: { name: string, id: number }) => {

    delete errors.expertise
    delete errors.experience
    setErros({ ...errors })



    let updatedSkill: { name: string, id: number, expertise: number, experience: "", other: boolean }
      = { ...skill, expertise: 0, experience: "", other: e === 'addValue' }


    if (skill !== null) {
      if (e.value || e === 'addValue') {
        addedSkills.push(updatedSkill)
        delete errors.expertise
        delete errors.experience
        setErros({ ...errors })
        if (skill.name === "Others") {
          setSkillOthers(true)
        }
      }
      else {
        const index = addedSkills.findIndex(item => item.id === skill.id);
        if (index > -1) {
          addedSkills.splice(index, 1);
        }
        if (skill.name === "Others") {
          setSkillOthers(false)
        }
      }
    }
    setAddedSkills([...addedSkills])
  }

  // const engineeringChange = (e: any, engineering: { name: string, id: number }) => {

  //   delete errors.engieering
  //   setErros({ ...errors })

  //   let updatedEngineering: { name: string, id: number, other: boolean }
  //     = { ...engineering, other: e === 'addValue' }

  //   if (engineering !== null) {
  //     if ((e.value) || e === 'addValue') {
  //       addedEngineering.push(updatedEngineering)
  //       delete errors.engieering
  //       setErros({ ...errors })
  //       if (engineering.name === "Others") {
  //         setEngineeringOthers(true)
  //       }
  //     }
  //     else {
  //       const index = addedEngineering.findIndex(item => item.id === engineering.id);;
  //       if (index > -1) {
  //         addedEngineering.splice(index, 1);
  //       }
  //       if (engineering.name === "Others") {
  //         setEngineeringOthers(false)
  //       }

  //     }
  //     setAddedEngineering([...addedEngineering])
  //     setErros({ ...errors })
  //   }


  // }


  // const expertiseChange = (e: any, skill: any, fieldName: string, type: string) => {

  //   const index = addedSkills.indexOf(skill, 0);
  //   if (fieldName === "expertise") {
  //     addedSkills[index].expertise = e.value
  //   }
  //   else {
  //     if (type) {
  //       if (isNaN(parseInt(addedSkills[index].experience)))
  //         addedSkills[index].experience = "1"
  //       else {
  //         switch (type) {
  //           case "add":
  //             addedSkills[index].experience = (parseInt(addedSkills[index].experience) + 1).toString()
  //             break
  //           case "subtract":
  //             addedSkills[index].experience = (parseFloat(addedSkills[index].experience) - 1).toString()
  //             break
  //         }
  //       }

  //     }
  //     else
  //       addedSkills[index].experience = e.target.value
  //   }
  //   delete errors.expertise
  //   delete errors.experience
  //   setErros({ ...errors })
  //   setAddedSkills([...addedSkills])
  // }

  const experienceChange = (e: any, fieldName: string) => {
    delete errors.workExp
    workExp[fieldName] = e.target.value ? Math.abs(e.target.value) : ''
    setWorkExp({ ...workExp })
    setErros({ ...errors })
  }


  const {
    // register,
    handleSubmit,
    // formState: { errors },
  } = useForm();

  const saveWithoutValidation = () => {

    let techStack: any[] = []
    // let jobRoles: any[] = []
    // let rolesWithoutOthers = addedEngineering.filter((item) => item.name !== 'Others').filter((item) => item.id !== 0)
    const skillWithoutOthers = addedSkills.filter((item) => item.name !== 'Others').filter((item) => item.id !== 0)
    

    // jobRoles = rolesWithoutOthers.map((item, i) => {
    //   return ({
    //     "name": item.name,
    //     "id": item.id
    //   })
    // })

    techStack = skillWithoutOthers.map((item, i) => {

      return ({
        "stackId": i,
        "skill": {
          "skillId": item.id,
          "skillName": item.name
        },
        "experience": item.experience,
        "expertise": item.expertise
      })
    })

    let data = {
      profileMetadata: {
        "workExperience": parseFloat(`${workExp.years}.${workExp.months}`),
        // "jobRoles": jobRoles,
        "techStack": techStack,
      }, "loginId": loginId,
      "candidateStatus": '1'

    }
    
    Back(data)
  }


  const onSubmit = () => {
    
    let isErrored = false
    let techStack: any[] = []
    // let jobRoles: any[] = []
    // let rolesWithoutOthers = addedEngineering.filter((item) => item.name !== 'Others')


    if (!workExp.years && workExp.years !== 0) {
      errors.workExp = "Please add your years of experience"
      isErrored = true
    }

    // if ((!rolesWithoutOthers || rolesWithoutOthers.length === 0)) {
    //   errors.engieering = "Select atleast one role "
    //   isErrored = true
    // } else if (rolesWithoutOthers.length > 3) {
    //   errors.engieering = "Maximum three roles are allowed"
    //   isErrored = true
    // }

    const skillWithoutOthers = addedSkills.filter((item) => item.name !== 'Others')
    

    if ((!skillWithoutOthers || skillWithoutOthers.length === 0)) {
      errors.expertise = "Please add atleast one skill "
      isErrored = true
    }
    if (skillWithoutOthers.length > 3) {
      errors.expertise = "Maximum three skills are allowed"
      isErrored = true
    }
    
    if (englishProficiencyValue === undefined) {
      errors.englishProficiency = "Please select english proficiency"
      isErrored = true
    }

    // jobRoles = rolesWithoutOthers.map((item, i) => {
    //   return ({
    //     "name": item.name,
    //     "id": item.id
    //   })
    // })

    techStack = skillWithoutOthers.map((item, i) => {

      // if (!item.experience) {
      //   errors.expertise = "Please add experience"
      //   isErrored = true
      //   return
      // }
      // else if (!item.expertise) {
      //   errors.expertise = "Please add the expertise "
      //   isErrored = true
      //   return
      // }

      return ({
        "stackId": i,
        "skill": {
          "skillId": item.id,
          "skillName": item.name
        },
        "experience": item.experience.toString(),
        "expertise": item.expertise
      })
    })



    if (isErrored) {
      setErros({ ...errors })
      return
    }

    let data = {
      profileMetadata: {
        "workExperience": parseFloat(`${workExp.years}.${workExp.months}`),
        "techStack": techStack,
        "englishProficiency" : englishProficiencyValue
      }, 
      "loginId": loginId,
      "candidateStatus": '1'
    }
    OnSubmit(data)
  }

  // const getDefaultJobRoles = (item: { name: string, id: number }) => addedEngineering ? !!addedEngineering.filter(id => id.id === item.id).length : false
  const getDefaultSkills = (item: { name: string, id: number }) => addedSkills ? !!addedSkills.filter(id => id.id === item.id).length : false


  const getAddedSkills = () => [...CONSTANTS.Skills, ...addedSkills.filter(item => item.other)]
  // const getAddedEngineering = () => [...CONSTANTS.Engineering, ...addedEngineering.filter(item => item.other)]

  const languageProficiency = (e: any, name: any) => {
    
    delete errors.englishProficiency
    setEnglishProficiency(e.value)
    if(e.value === 1){
      setEnglishProficiencyValue({languageId: uuidv4(), name: "English",proficiency: 'Expert'})
    }else if(e.value === 2){
      setEnglishProficiencyValue({languageId: uuidv4(), name: "English",proficiency: 'Intermediate'})
    }else{
      setEnglishProficiencyValue({languageId: uuidv4(), name: "English",proficiency: 'Intermediate'})
    }
  }

  return (
    <>
    
      <Headline4>Tell us what are you good at? </Headline4>
      <FromHead>
        How many years of professional experience do you have ?
      </FromHead>
      <div className="form-group">
        <p className={Styles.experienceWrap}>
          I have
          <Freefield
            id="years"
            placeholder=""
            autoComplete='off'
            type='number'
            size="small"
            value={workExp.years}
            onChange={(e: any) => experienceChange(e, "years")}
          />
          years and
          <Freefield
            id="months"
            placeholder=""
            autoComplete='off'
            type='number'
            size="small"
            // min="0"
            value={workExp.months}
            onChange={(e: any) => experienceChange(e, "months")}
          />
          months of experience in software development
        </p>
        <Error>{errors?.workExp}</Error>

      </div>
      {/* <FromHead>
        What engineering role identifies you better?
      </FromHead>

      <div className={Styles.tagLabelWrap}>
        {getAddedEngineering().map((item, key) => <TagLabel label={item.name}
          key={key}
          value={item.id}
          checked={getDefaultJobRoles(item)}
          handleChange={(e: any) => engineeringChange(e, item)} />)}
        {engineeringOthers && <div className={Styles.tagDropdown}>
          <Combodropdown
            placeholder="Please search your role"
            data={jobRoles}
            name='name'
            id='id'
            handleChange={(value: { name: string, id: number, other: boolean }) => engineeringChange('addValue', value)
            }
          />
        </div>}
        <Error>{errors?.engieering}</Error>

      </div> */}
      <FromHead>
        Which are the skills you’re really good at?
      </FromHead>
      <p>Please add (at least one or max of three of) your Core skills</p>
      <div className={Styles.tagLabelWrap}>
        {getAddedSkills().map((skill, key) => <TagLabel label={skill.name}
          key={key}
          value={skill.id}
          checked={getDefaultSkills(skill)}
          handleChange={(e: any) => skillChange(e, skill)} />)}

        {skillOthers && <div className={Styles.tagDropdown}>
          <Combodropdown
            placeholder="Please search your skill"
            data={skills}
            name='name'
            id='id'
            handleChange={(value: { name: string, id: number }) => skillChange("addValue", value)}
          />
        </div>}
        <Error>{errors?.expertise}</Error> 
      </div>
      <FromHead>What is your proficiency in English ?*</FromHead>
        <div className="form-group mb-40">
          <div className={Styles.noBorderRadio}>
            <RadioGroup 
              data={CONSTANTS.englishProficiency}
              layout="horizontal"
              handleChange={(e: any) => languageProficiency(e,'languageProficiency')}
              checked={englishProficiency}
            />
          </div>
          <Error>{errors?.englishProficiency}</Error>
        </div>
      {/* <FromHead>
        Add your experience and how competent you are with each of them?
      </FromHead>
      <p>This is based on your skill selection from above section</p>
      {addedSkills.filter((item) => item.name !== 'Others').map((skill, key) => <div className={Styles.tachSkills} key={key}>
        <label className={Styles.techLabel}>{skill.name}</label>
        <div className={Styles.skillValue}>
          <button onClick={(e: any) => expertiseChange(e, skill, "experience", "subtract")} disabled={(!skill.experience || skill.experience === '0') ? true : false}>
            <Icon icon="akar-icons:circle-minus"
            /></button>
          <div className={classnames('form-group', Styles.valueInput)}>
            <FreeField
              id="experience"
              placeholder="experience"
              size="small"
              type='number'
              value={skill.experience}
              onChange={(e: any) => expertiseChange(e, skill, "experience", "")}
            />
          </div>
          <button onClick={(e: any) => expertiseChange(e, skill, "experience", "add")}
          ><Icon icon="akar-icons:circle-plus" /></button>
        </div>
        <div className={Styles.expertValueWrap}>
          <RadioGroup data={CONSTANTS.Expertise}
            layout="horizontal"
            handleChange={(e: any) => expertiseChange(e, skill, "expertise", "")}
            checked={skill.expertise} />

        </div>
      </div>)}
      <Error>{errors?.experience}</Error>*/}
      <div className={Styles.formAction}>
        <Button onClick={handleSubmit(saveWithoutValidation)} variant="secondary">Back</Button>
        <Button onClick={handleSubmit(onSubmit)} variant="primary">Now , Add your Availability</Button>
      </div>
    </>
  );
}

export default SkillDetails;